import React, { useEffect, useState } from "react";

export const CategoriaSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-categoria"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="T">Total</option>
      <option value="R">Recuperado</option>
      <option value="C">Conveniado</option>
      <option value="P">Sin Gestión</option>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};